export const THREE_DECIMAL_REGEX = /^(\d*)(\.\d)?\d{0,2}$/;
export const DECIMAL_REGEX = /^(\d*)(\.\d+)?$/;

export const ORDER_STATUS_CODE = {
    PROCESSING: 1,
    ORDER_ACCEPTED: 2,
    PACKING_IN_PROCESS: 3,
    SHIPPED: 4,
    DELIVERED: 5,
    COMPLETED: 6,
    CANCELLED: 7,
    RETURN_REQUESTED: 8,
    RETURN_REJECTED: 9,
    RETURN_ACCEPTED: 10,
    REFUNDED: 11,
    REFUND_INITIATED: 12,
    REFUND_COMPLETED: 13,
    RETURN_DELIVERED: 14,
    RETURN_SHIPPED: 15,
    PARTIAL_REFUND: 16,
    FULL_REFUND: 17,
  };

export const VIEW_ORDER_SHIPMENT_STATUS = [
    ORDER_STATUS_CODE.RETURN_SHIPPED,
    ORDER_STATUS_CODE.RETURN_ACCEPTED
];

export const REFUND_ORDER_STATUS = [
  // ORDER_STATUS_CODE.RETURN_DELIVERED,
  ORDER_STATUS_CODE.PARTIAL_REFUND,
  ORDER_STATUS_CODE.FULL_REFUND,
];

export const VIEW_RETURN_REASON_STATUS = [
  ORDER_STATUS_CODE.RETURN_REQUESTED,
  ORDER_STATUS_CODE.RETURN_REJECTED,
  ORDER_STATUS_CODE.RETURN_ACCEPTED,
  ORDER_STATUS_CODE.REFUNDED,
  ORDER_STATUS_CODE.REFUND_INITIATED,
  ORDER_STATUS_CODE.REFUND_COMPLETED,
  ORDER_STATUS_CODE.RETURN_DELIVERED,
  ORDER_STATUS_CODE.RETURN_SHIPPED,
];

export const ORDER_STATUS_COLOR_CLASS = {
  [ORDER_STATUS_CODE.PROCESSING]: "placed",
  [ORDER_STATUS_CODE.ORDER_ACCEPTED]: "accepted",
  [ORDER_STATUS_CODE.PACKING_IN_PROCESS]: "packing",
  [ORDER_STATUS_CODE.SHIPPED]: "shipped",
  [ORDER_STATUS_CODE.DELIVERED]: "delivered",
  [ORDER_STATUS_CODE.COMPLETED]: "completed",
  [ORDER_STATUS_CODE.CANCELLED]: "cancelled",
  [ORDER_STATUS_CODE.RETURN_REQUESTED]: "requested",
  [ORDER_STATUS_CODE.RETURN_REJECTED]: "rejected",
  [ORDER_STATUS_CODE.RETURN_ACCEPTED]: "return",
  [ORDER_STATUS_CODE.REFUNDED]: "refunded",
  [ORDER_STATUS_CODE.REFUND_INITIATED]: "initiated",
  [ORDER_STATUS_CODE.REFUND_COMPLETED]: "refunded",
  [ORDER_STATUS_CODE.RETURN_DELIVERED]: "return",
  [ORDER_STATUS_CODE.RETURN_SHIPPED]: "return",
  [ORDER_STATUS_CODE.PARTIAL_REFUND]: "partial-refund",
  [ORDER_STATUS_CODE.FULL_REFUND]: "full-refund",
}

export const BLOCK_ON_CHANGE_ORDER_STATUS_API = [
  ORDER_STATUS_CODE.PARTIAL_REFUND,
  ORDER_STATUS_CODE.FULL_REFUND,
];

export const IMAGE_CONSTANTS = {
  STORE_LOGO_PATH: 'storeLogo',
  EMAIL_LOGO_PATH: 'emailLogo', 
  INVOICE_LOGO_PATH: 'invoiceLogo', 
}

export const SKIP_AUTHORIZATION = "X-Skip-Authorization";